
import { defineComponent } from "vue"
import { useStore } from "vuex"

export default defineComponent({
  props: {
    title: {
      type: String,
      default: "",
    },
    subTitle: {
      type: String,
      default: "",
    },
    command: {
      type: String,
      default: "",
    },
  },
  setup() {
    const { dispatch } = useStore()
    const executeButton = (command: String) => {
      switch (command) {
        case "callDirect":
          dispatch("callgate/callDirect")
          break
        case "showMore":
          dispatch("callgate/showMore")
          break
        default:
          alert("입력값없음")
          break
      }
    }
    return {
      executeButton,
    }
  },
})
